import { createSelector } from 'reselect'

const getUserData = state => state.user
const getMyAccountData = state => state.myAccount

const defaultData = {
	firstName: '',
	lastName: '',
	email: '',
	hasPassword: false,
	institutionName: '',
	institutionId: 0,
	country: 0,
	zipCode: '',
	grades: [],
	gradeIds: [],
	subjects: [],
	subjectIds: [],
	countries: [],
	countryId: '',
	states: [],
	stateId: '',
	city: '',
	countryIdUS: 0,
	canEditInstitution: true,
	showSchoolOnly: true,
}

function onlyShowSchool(countryId, stateId, city, countryIdUS, canEditInstitution) {
	if (canEditInstitution) {
		return true
	}
	if (countryId == 0 || countryId == -1) {
		return false
	} else if (countryId == countryIdUS) {
		if (stateId == 0 || stateId == -1) {
			return false
		} else {
			return true
		}
	} else if (city == '') {
		return false
	} else {
		return true
	}
}

const profileViewSelector = createSelector(
	[ getUserData, getMyAccountData ],
	(userData, myAccountData) => {
		let userMyAccountData = {}
		let userDataLoaded = false
		if (userData.fullDataLoaded && myAccountData.loaded) {
			userMyAccountData.firstName = userData.data.firstName
			userMyAccountData.lastName = userData.data.lastName
			userMyAccountData.email = userData.data.email
			userMyAccountData.hasPassword = myAccountData.data.hasPassword
			userMyAccountData.institutionName = myAccountData.data.institutionName
			userMyAccountData.country = myAccountData.data.country
			userMyAccountData.zipCode = myAccountData.data.zipCode
			userMyAccountData.grades = myAccountData.data.grades
			userMyAccountData.gradeIds = myAccountData.data.gradeIds
			userMyAccountData.subjects = myAccountData.data.subjects
			userMyAccountData.subjectIds = myAccountData.data.subjectIds
			userMyAccountData.countries = myAccountData.data.countries
			userMyAccountData.countryId = myAccountData.data.countryId
			userMyAccountData.countryIdUS = myAccountData.data.countryIdUS
			userMyAccountData.states = myAccountData.data.states
			userMyAccountData.stateId = myAccountData.data.stateId
			userMyAccountData.city = myAccountData.data.city
			userMyAccountData.canEditInstitution = myAccountData.data.canEditInstitution
			userMyAccountData.showSchoolOnly = onlyShowSchool(myAccountData.data.countryId, myAccountData.data.stateId,
				myAccountData.data.city, myAccountData.data.countryIdUS, myAccountData.data.canEditInstitution)
			userDataLoaded = true
		} else {
			userMyAccountData = defaultData
		}
		return {
			schools: myAccountData.schools,
			showSchoolButtons: myAccountData.showSchoolButtons,
			showTeacherButtons: myAccountData.showTeacherButtons,
			showProfileImageUploading: myAccountData.showProfileImageUploading,
			emailDisabled: myAccountData.loaded && (!myAccountData.data.hasPassword || !myAccountData.data.isNearpodLogin),
			personalInfoErrors: myAccountData.personalInfoErrors,
			changePasswordErrors: myAccountData.changePasswordErrors,
			userData: userMyAccountData,
			userDataLoaded,
		}
	}
)

export default profileViewSelector
